var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M 25 2 C 12.296875 2 2 12.296875 2 25 C 2 37.703125 12.296875 48 25 48 C 37.703125 48 48 37.703125 48 25 C 48 12.296875 37.703125 2 25 2 Z M 25 7 C 34.925781 7 43 15.074219 43 25 C 43 34.925781 34.925781 43 25 43 C 15.074219 43 7 34.925781 7 25 C 7 15.074219 15.074219 7 25 7 Z M 25 9 C 16.179688 9 9 16.179688 9 25 C 9 33.820313 16.179688 41 25 41 C 33.820313 41 41 33.820313 41 25 C 41 16.179688 33.820313 9 25 9 Z M 32 18 L 25.734375 35 L 23.050781 26.949219 L 15 24.265625 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirect);
export default __webpack_public_path__ + "static/media/redirect.6ca303e206348637a0508fb90cb6f77a.svg";
export { ForwardRef as ReactComponent };